import React from 'react';
import ThumbOverlayDefault from '@wix/da-ds/pkg/thumbs/ThumbOverlayDefault';
import { isVideoOrGif, getVideoDuration } from '../../../../utils/deviations';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import { isMultiImageDeviation } from '../../../_helpers';
import { useDeviationBlockType } from '../../hooks/useDeviationBlockType';
import DeviationThumbStatusIndicators from '../DeviationThumbIndicators';
const DeviationThumbOverlayDefault = ({ deviation, width, height, isFaved, hasCommentedOn, children, className })=>{
    const blockType = useDeviationBlockType(deviation);
    const { showPermanentEngagementIcon, showMediaIndicators } = useOverlayContext(deviation);
    return /*#__PURE__*/ React.createElement(ThumbOverlayDefault, {
        width: width,
        height: height,
        isFaved: showPermanentEngagementIcon && isFaved,
        isCommented: showPermanentEngagementIcon && hasCommentedOn,
        statusIndicators: !blockType && /*#__PURE__*/ React.createElement(DeviationThumbStatusIndicators, {
            deviation: deviation
        }),
        isMultiImage: isMultiImageDeviation(deviation),
        mediaIndicator: showMediaIndicators && !blockType ? isVideoOrGif(deviation) : undefined,
        duration: getVideoDuration(deviation),
        className: className
    }, children);
};
DeviationThumbOverlayDefault.displayName = 'DeviationThumbOverlayDefault';
export default DeviationThumbOverlayDefault;

//# sourceMappingURL=DeviationThumbOverlayDefault.js.map